import { BaseRouteService } from 'core/services';

class CancelOrderLineRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'cancel-order/';
	}

	cancelAmazonOrder(id, sourceOfChange) {
		return super.get(this.base + 'cancel-amazon-order/{id}/?sourceOfChange={sourceOfChange}', id, { sourceOfChange });
	}

	cancelMiraklOrder(id, sourceOfChange) {
		return super.get(this.base + 'cancel-mirakl-order/{id}/?sourceOfChange={sourceOfChange}', id, { sourceOfChange });
	}

	refundOrderLine(id, sourceOfChange) {
		return super.get(this.base + 'refund-order-line/{id}/?sourceOfChange={sourceOfChange}', id, { sourceOfChange });
	}

	refundAllOrderLines(id, sourceOfChange) {
		return super.get(this.base + 'refund-order/{id}/?sourceOfChange={sourceOfChange}', id, { sourceOfChange });
	}

	cancelWalmartOrderLines(sourceOfChange) {
		return super.update(this.base + 'cancel-walmart-order-lines/?sourceOfChange={sourceOfChange}', {
			sourceOfChange,
		});
	}
}

export default CancelOrderLineRouteService;
